import { Casting } from "./Casting"


export const CastingPage = () => {


    return (
            <Casting />
    )
}